import React from "react";
import CommonListItemsComp from "../common/List";

const ListCommercialProperties = (props) => {
    return <CommonListItemsComp {...props}/>
}

export default ListCommercialProperties;
